import {Injectable, Injector} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {of} from 'rxjs';
import {catchError, map, mergeMap} from 'rxjs/operators';

import * as ac from './actions.command.benutzer-backend-admin-setzen-admin';
import * as api from '../../../clients/benutzerverwaltung';

@Injectable()
export class BenutzerverwaltungBenutzerBackendAdminSetzenAdminEffects {

    BenutzerBackendAdminSetzenAdmin$ = createEffect(() => this.actions$.pipe(
        ofType(ac.POST_BENUTZER_BACKEND_ADMIN_SETZEN_ADMIN),
        mergeMap((x: ac.PostBenutzerBackendAdminSetzenAdminAction) => {
            const optPayload = (x !== undefined && x !== null && x.optPayload !== undefined) ? x.optPayload : null;
            return this.getService().postBenutzerBackendAdminSetzenAdmin(x.benutzerBackendAdminRequest).pipe(
                map((result: any) => {
                    return new ac.PostBenutzerBackendAdminSetzenAdminErfolgreichAction(result, x.benutzerBackendAdminRequest, optPayload);
                }),
                catchError((error: any) => {
                    const nextAction = new ac.PostBenutzerBackendAdminSetzenAdminFehlerAction(error, x.benutzerBackendAdminRequest, optPayload);
                    return of(nextAction);
                })
            );
        })
    ));

    private service: api.BenutzerverwaltungAdminCommandService = null;

    constructor(private actions$: Actions, private injector: Injector) {
    }

    private getService(): api.BenutzerverwaltungAdminCommandService {
        if (this.service === null) {
            this.service = this.injector.get(api.BenutzerverwaltungAdminCommandService);
        }
        return this.service;
    }
}
